import React from 'react';
import { AsperaError } from '../../classes/AsperaError';
import '../../styles/components/AsperaTooltip.scss';
import { Button, getIcon, ToggletipLabel, Toggletip, ToggletipButton, ToggletipContent, Tooltip } from '../Carbon';
/**
 * React Component
 *
 * The AsperaTooltip component renders a tooltip from Carbon
 *
 * @example
 * ```javascript
 * <AsperaTooltip />
 * ```
 */
export class AsperaTooltip extends React.Component {
    render() {
        const { className, children, align, useTextOnly, tooltipLabel } = this.props;
        if (!useTextOnly) {
            let alignToUse = align;
            if (typeof alignToUse === 'string' && alignToUse.includes('-')) {
                new AsperaError('AsperaTooltip: rich content mode used invalid alignment', { align });
                alignToUse = alignToUse.split('-')[0];
            }
            return (React.createElement("div", { className: `aspera-tooltip aspera-tooltip--rich-content ${className ? className : ''}`, "data-auto": "aspera-tooltip--wrapper" },
                !!tooltipLabel && React.createElement(ToggletipLabel, null, tooltipLabel),
                React.createElement(Toggletip, { align: alignToUse },
                    React.createElement(ToggletipButton, { className: "aspera-tooltip--rich-icon" }, getIcon('Information')),
                    React.createElement(ToggletipContent, null, children))));
        }
        return (React.createElement("div", { className: `aspera-tooltip ${className ? className : ''}`, "data-auto": "aspera-tooltip--wrapper" },
            React.createElement(Tooltip, { label: children, align: align },
                React.createElement(Button, { className: "aspera-tooltip--button", kind: "ghost", size: "sm" }, getIcon('Information')))));
    }
}
